import { Component, Input, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CreateOrganisationHierarchyService } from './create-organisation-hierarchy.service';
import { TabsService } from '../../tabs.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ViewLevelUsersComponent } from '../view-level-users/view-level-users.component';
import { UsersService } from '../users/users.service';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
	selector: 'app-create-organisation-hierarchy',
	templateUrl: './create-organisation-hierarchy.component.html',
	styleUrls: ['./create-organisation-hierarchy.component.scss']
})
export class CreateOrganisationHierarchyComponent implements OnInit {
	selectedAccordionIndex: any = null;
	blockLoader: string = 'blockLoader';
	isTemplateSelected: boolean = false;
	// allTemplates: any = [];
	selectedTemplate: any;
	@Input() organisationId: string = '';
	organisationHierarchy: any = [];
	totalHierarchies: number = 0;
	currentHierarchies: number = 0;
	// usersSub: any;
	canEditHierarchy!: boolean;
	canAddToFirstLevel: boolean = false;
	managers: any
	newFirstLevelName: string = '';
	// orgAllUsers: any;
	rolesData: any;
	templateSub: any;
	managerNames: any = {};
	orgCode: string = '';
	accordionActiveId: number = -1;
	shouldShowInnerHierarchy: any = [];

	constructor(
		private dialog: MatDialog,
		private snackbar: MatSnackBar,
		private tabsService: TabsService,
		private usersService: UsersService,
		private spinner: NgxSpinnerService,
		private sharedService: SharedService,
		private createOrganisationHierarchyService: CreateOrganisationHierarchyService
	) {
		this.tabsService.organisationId$.subscribe(async organisationId => {
			if (organisationId) {
				this.organisationId = organisationId;
				const orgData = await this.createOrganisationHierarchyService.getOrgTemplate();
				this.organisationHierarchy = orgData.hierarchy;
				// console.log(this.organisationHierarchy);
				this.orgCode = orgData.orgCode;
				this.currentHierarchies = this.totalHierarchies;

				for (let item of this.organisationHierarchy[0].values) {
					this.shouldShowInnerHierarchy.push(false);
				}
			}
		});
	}

	async ngOnInit() {
		this.templateSub = this.createOrganisationHierarchyService.getOrgTemplateObs().subscribe((template: any) => {
			this.initialTemplateSelection(template);
		});
		await this.spinner.show("blockLoader");
		this.rolesData = await this.usersService.getOrgRoles(this.organisationId);
		await this.spinner.hide("blockLoader");

		// this.usersSub = this.usersService.getAllUsersObs(this.organisationId).subscribe((users: any) => {
		// 	this.orgAllUsers = users;
		// 	if (this.orgAllUsers.length > 0) {
		// 		// console.log('loading roles');
		// 		// await this.spinner.show("blockLoader");
		// 		for (let u of this.orgAllUsers) {
		// 			const roleId = String(u.roleId);
		// 			u.role = this.rolesData[roleId];
		// 		}
		// 	}

		// 	for (const user of users) {
		// 		this.managerNames[user.id] = user.name;
		// 	}
		// });
	}

	async saveOrganisationHierarchy() {
		// await this.spinner.show("blockLoader");
		const updatedHierarchy = await this.createOrganisationHierarchyService.mergeOrganisationHierarchy(this.organisationId, this.organisationHierarchy);
		this.syncHierarchyState(updatedHierarchy);
		await this.spinner.hide("blockLoader");
		this.snackbar.open("Organisation hierarchy has been created!", "OK", {
			duration: 3000
		});
	}

	isSaveHierarchyDisabled() {
		if (!this.isTemplateSelected || (this.currentHierarchies !== this.totalHierarchies) || !this.canEditHierarchy) {
			return true;
		}

		return false;
	}

	initialTemplateSelection(template: any) {
		if (!template || Object.keys(template).length === 0) {
			return;
		}
		this.selectedTemplate = template;
		this.isTemplateSelected = true;
		this.totalHierarchies = this.selectedTemplate.hierarchies.length;
		this.sortByValues();

		if (this.organisationHierarchy && this.organisationHierarchy.length >= 1) {
			this.currentHierarchies = this.totalHierarchies;
		} else {
			this.currentHierarchies = 0;
			this.organisationHierarchy = [];
		}
	}

	getPlaceholderForHierarchy(hierarchy: any) {
		return `SELECT ${hierarchy.name.toUpperCase()}`;
	}

	placeholderNonEditableHierarchy(hierarchy: any) {
		return `${hierarchy.toUpperCase()}`;
	}

	// initialHierarchySelection(event: any, hierarchyOption: string) {
	// 	if (event.checked) {
	// 		if (this.organisationHierarchy.length === 0) {
	// 			this.organisationHierarchy.push({
	// 				name: this.selectedTemplate.hierarchies[0].name,
	// 				values: [{
	// 					levels: [],
	// 					value: hierarchyOption
	// 				}]
	// 			});
	// 			this.currentHierarchies = 1;
	// 		} else {
	// 			this.organisationHierarchy[0].values.push({
	// 				levels: [],
	// 				value: hierarchyOption
	// 			});
	// 		}
	// 	} else {
	// 		const indexOfHierarchyValue = this.organisationHierarchy[0].values.findIndex((val: any) => val.value === hierarchyOption);
	// 		this.organisationHierarchy[0].values.splice(indexOfHierarchyValue, 1);
	// 		this.clearInnerSelections([hierarchyOption]);

	// 		if (this.organisationHierarchy[0].values.length === 0) {
	// 			this.organisationHierarchy = [];
	// 			this.currentHierarchies = 0;
	// 		}
	// 	}

	// 	console.log(this.organisationHierarchy);
	// }

	isInitialHierarchySelected(hierarchyOption: any) {
		if (this.organisationHierarchy && this.organisationHierarchy[0]) {
			const foundIndex = this.organisationHierarchy[0].values.findIndex((item: any) => item.value === hierarchyOption);

			if (foundIndex === -1) {
				return false;
			}

			return true;
		}

		return false;
	}

	updateCurrentHierarchies(updatedVal: number) {
		this.currentHierarchies = updatedVal;
	}

	syncHierarchyState(updatedHierarchy: any) {
		this.organisationHierarchy = updatedHierarchy || [];
		if (this.selectedTemplate) {
			this.selectedTemplate.hierarchy = this.organisationHierarchy;
		}
		this.currentHierarchies = this.organisationHierarchy.filter((level: any) => level?.values?.length).length;
		this.shouldShowInnerHierarchy = (this.organisationHierarchy[0]?.values || []).map((_: any, index: number) => {
			return this.shouldShowInnerHierarchy[index] || false;
		});
		this.sortByValues();
	}

	async editHierarchyToggle() {
		if (!this.canEditHierarchy) {
			this.organisationHierarchy = await this.createOrganisationHierarchyService.getOrganisationHierarchy(this.organisationId);
			if (this.organisationHierarchy.length >= 1) {
				this.currentHierarchies = this.totalHierarchies;
			}
		}
	}

	async viewLevelDetails(levelName: string, levelValue: any, index: number) {
		// await this.spinner.show("blockLoader");
		// console.log(levelValue);
		let levels = [{
			name: levelName,
			value: levelValue.value
		}];
		const filteredUsers: any = await this.createOrganisationHierarchyService.getUsersAtLevel(levels, this.organisationId);
		// console.log('filteredUsers--',filteredUsers);
		await this.spinner.hide("blockLoader");

		// console.log(this.organisationHierarchy);
		this.dialog.open(ViewLevelUsersComponent, {
			maxWidth: '80%',
			minWidth: '60%',
			data: {
				filteredUsers,
				hierarchyOption: levelValue,
				levelName,
				levels,
				organisationId: this.organisationId,
				organisationHierarchy: this.organisationHierarchy,
				levelIndex: 0,
				globalIndex: index,
				// allUsers: this.orgAllUsers,
				rolesData: this.rolesData,
				orgCode: this.orgCode,
			}
		});
	}

	clearInnerSelections(parents: any) {
		for (let i = 0; i < this.organisationHierarchy.length; i += 1) {
			let orgHierarchy = this.organisationHierarchy[i];

			for (let j = 0; j < orgHierarchy.values.length; j += 1) {
				let orgValue = orgHierarchy.values[j];

				if (orgValue.levels.length >= parents.length && this.matchElementsOrder(parents, orgValue.levels)) {
					orgHierarchy.values.splice(j, 1);
				}
			}
		}
	}

	matchElementsOrder(checkForArray: any, checkInArray: any) {
		for (let i = 0; i < checkForArray.length; i += 1) {
			let checkForItem = checkForArray[i];

			if (checkForItem !== checkInArray[i]) {
				return false;
			}
		}
		return true;
	}

	changeInputState(status: string, index: number) {
		const divElement = document.getElementById('newLevel-' + index);
		if (divElement) {
			if (status === 'show') {
				divElement.classList.remove('hidden');
				// divElement.classList.add('block-element');
			} else if (status === 'hide') {
				// divElement.classList.remove('block-element');
				divElement.classList.add('hidden');
			}
		}
	}

	firstLevelAddStateChange(status: string) {
		if (status === 'show') {
			this.canAddToFirstLevel = true;
		} else if (status === 'hide') {
			this.canAddToFirstLevel = false;
		}
	}

	isLevelNameAdded(index: number) {
		const inputElement: any = document.getElementById('newLevelName-' + index);
		if (inputElement) {
			return inputElement.value.length >= 1;
		}
	}

	async addNewFirstLevel() {
		let msg = '';
		const newLevelValue = this.newFirstLevelName.toLowerCase().trim();
		const newLevelDisplayValue = this.newFirstLevelName.trim();
		// await this.spinner.show("blockLoader");
		// console.log(this.organisationHierarchy);
		if (this.organisationHierarchy.length === 0) {
			const updatedHierarchy = await this.createOrganisationHierarchyService.addHierarchyValue(this.organisationId, 0, this.selectedTemplate.hierarchies[0], {
				levels: [],
				value: newLevelValue,
				displayValue: newLevelDisplayValue
			});
			this.syncHierarchyState(updatedHierarchy);
			msg = "Level added successfully!";
			this.newFirstLevelName = "";
			this.canAddToFirstLevel = false;
		} else {
			let levelAlreadyExists = false;
			for (let val of this.organisationHierarchy[0].values) {
				if (val.value === newLevelValue) {
					levelAlreadyExists = true;
					break;
				}
			}

			if (!levelAlreadyExists) {
				const updatedHierarchy = await this.createOrganisationHierarchyService.addHierarchyValue(this.organisationId, 0, this.selectedTemplate.hierarchies[0], {
					levels: [],
					value: newLevelValue,
					displayValue: newLevelDisplayValue
				});
				this.syncHierarchyState(updatedHierarchy);
				msg = "Level added successfully!";
				this.newFirstLevelName = "";
				this.canAddToFirstLevel = false;
			} else {
				msg = "A level already exists by this name";
			}
		}
		await this.spinner.hide("blockLoader");
		this.snackbar.open(msg, "OK", {
			duration: 3000
		});

		// if (msg === "Level added successfully!") {
		// 	setTimeout(() => {
		// 		location.reload();
		// 	}, 2000);
		// }
	}

	async addHierarchyLevel(prevValue: any, index: number, expansionPanelId: any) {
		const inputElement: any = document.getElementById('newLevelName-' + index);
		// console.log(inputElement);
		if (inputElement) {
			const levelName = inputElement.value;
			let valToCompare = String(inputElement.value).toLowerCase().trim();
			let msg = "";
			const firstLevelVals = this.organisationHierarchy[1]?.values ? this.organisationHierarchy[1]?.values : [];
			let levelAlreadyExists = false;

			for (let val of firstLevelVals) {
				if (val.levels[0] === prevValue && val.value === valToCompare) {
					levelAlreadyExists = true;
					break;
				}
			}

			if (levelAlreadyExists) {
				msg = "A level already exists by this name";
			} else {
				if (this.organisationHierarchy.length > 1) {
					const updatedHierarchy = await this.createOrganisationHierarchyService.addHierarchyValue(this.organisationId, 1, this.selectedTemplate.hierarchies[1], {
						levels: [prevValue],
						value: String(levelName).toLowerCase().trim(),
						displayValue: String(levelName).trim()
					});
					this.syncHierarchyState(updatedHierarchy);
				} else {
					const updatedHierarchy = await this.createOrganisationHierarchyService.addHierarchyValue(this.organisationId, 1, this.selectedTemplate.hierarchies[1], {
						levels: [prevValue],
						value: String(levelName).toLowerCase().trim(),
						displayValue: String(levelName).trim()
					});
					this.syncHierarchyState(updatedHierarchy);
				}
				await this.spinner.hide("blockLoader");
				msg = "Level added successfully!";
				inputElement.value = "";
				this.changeInputState('hide', index);
				this.sortByValues();
				this.accordionActiveId = expansionPanelId;
			}

			this.snackbar.open(msg, "OK", {
				duration: 3000
			});
		}
	}

	isAccordionExpanded(index: number): boolean {
		return this.selectedAccordionIndex === index;
	}

	sortByValues() {
		for (let i = 0; i < this.selectedTemplate.hierarchy.length; i += 1) {
			const values = this.selectedTemplate.hierarchy[i].values.slice();

			this.selectedTemplate.hierarchy[i].values = this.selectedTemplate.hierarchy[i].values.sort((a: any, b: any) => {
				return a.value < b.value ? - 1 : 1;
			});

			for (let val of this.selectedTemplate.hierarchy[i].values) {
				const pos = this.findPositionInValues(val, values);
				val.orgIndex = pos;
				// console.log(`set ${val.value} to ${pos}`);
			}
		}

		// console.log(this.selectedTemplate.hierarchy);
	}

	findPositionInValues(val: any, values: any) {
		return values.findIndex((valueObj: any) => {
			return (valueObj.value === val.value && this.sharedService.areArraysEqual(val.levels, valueObj.levels));
		});
	}

	getManagerName(managerId: any): string {
		// console.log('managerId', managerId)
		// console.log('this.managerNames[managerId]', this.managerNames)
		const cachedName = this.managerNames[managerId];
		// console.log('cachedName', cachedName)
		if (cachedName) {
			return cachedName;
		}
		return '';
	}

	async deleteLevel(globalIndex: number, index: number, value: string) {
		let levels = [...this.organisationHierarchy[globalIndex].values[index].levels, value];
		let levelObjectStr = `name":"${this.organisationHierarchy[globalIndex].name}","value":"${value}`;
		// console.log(levelObjectStr);
		// let doesUserExist = this.sharedService.doesAnyUserExistAtLevel(levels, this.orgAllUsers);
		await this.spinner.show("blockLoader");
		let doesUserExist = await this.usersService.doesAnyUserExistAtLevel(levelObjectStr, this.organisationId);
		await this.spinner.hide("blockLoader");
		// console.log(doesUserExist);

		if (doesUserExist) {
			this.snackbar.open("You cannot delete this level at this time because users are present", "OK");
		} else {
			await this.spinner.show("blockLoader");
			const updatedHierarchy = await this.createOrganisationHierarchyService.deleteHierarchyBranch(this.organisationId, levels);
			this.syncHierarchyState(updatedHierarchy);
			await this.spinner.hide("blockLoader");
		}
	}

	deleteLevelsCascade(globalIndex: number, index: number, levels: any) {
		this.organisationHierarchy[globalIndex].values.splice(index, 1);

		for (let i = globalIndex + 1; i < this.organisationHierarchy.length; i += 1) {
			let vals = this.organisationHierarchy[i].values;

			for (let j = 0; j < vals.length; j += 1) {
				let valsJ = vals[j];

				if (this.sharedService.areArraysEqual(levels, valsJ.levels)) {
					this.organisationHierarchy[i].values.splice(j, 1);
				}
			}
		}
	}

	async showManagersList(hierarchyOption: any, enable: any) {
		if (enable) {
			// disable all tooltips so they don't remain visible.
			for (let hierarchyLevel of this.organisationHierarchy) {
				let values = hierarchyLevel.values;

				for (let levelValue of values) {
					levelValue.showManagersList = false;
				}
			}

			for (let hierarchyLevel of this.selectedTemplate.hierarchy) {
				let values = hierarchyLevel.values;

				for (let levelValue of values) {
					levelValue.showManagersList = false;
				}
			}

			if (hierarchyOption.hasLoadedManagers) {
				hierarchyOption.showManagersList = true;
				return;
			} else {
				await this.spinner.show("blockLoader");
				const res: any = await this.usersService.fetchMgrDetails(hierarchyOption.managers);
				await this.spinner.hide("blockLoader");

				hierarchyOption.managerNames = [];
				for (let user of res) {
					hierarchyOption.managerNames.push(user);
				}

				hierarchyOption.showManagersList = true;
				hierarchyOption.hasLoadedManagers = true;
			}
		} else {
			hierarchyOption.showManagersList = false;
		}
	}

	ngOnDestroy() {
		this.templateSub.unsubscribe();
		// if (this.usersSub) {
		// 	this.usersSub.unsubscribe();
		// }
	}

	shouldPanelExpand(panelIndex: number) {
		return this.accordionActiveId === panelIndex;
	}

	updateActiveAccordion(accordionActiveId: number) {
		this.accordionActiveId = accordionActiveId;
	}

	changeShowState(index: number) {
		for (let i = 0; i < this.shouldShowInnerHierarchy.length; i += 1) {
			if (i === index) {
				this.shouldShowInnerHierarchy[i] = true;
			} else {
				this.shouldShowInnerHierarchy[i] = false;
			}
		}
	}
}
